import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { ROUTES } from '../constants/routes';

function CatchAllRedirect() {
  const { user, token } = useContext(AuthContext);
  if (user && token) {
    return <Navigate to={ROUTES.HOME} replace />;
  }
  return <Navigate to={ROUTES.LOGIN} replace />;
}

export default CatchAllRedirect;
